<template lang="pug">
    div(v-if="renderMessaging" class="p-10 bg-gray-darkest items-center")
        div(class="max-w-[1000px] mx-auto w-full items-center justify-between flex md:flex-row flex-col")
            div(class="w-full mb-6 md:mr-20 md:mb-0")
                img(
                        src="@/assets/logos/made-by-rt-mark.svg"
                        alt="Made by Realtruck"
                        class="w-full"
                        width="498"
                        height="48"
                    )
            div(class="text-white")
                p(class="inline-block") #[span(class="font-bold") {{ brand }}] is a #[span(class="font-bold") RealTruck] brand. When you buy {{ brand }} from RealTruck, you are buying #[span(class="font-bold italic") direct] from the manufacturer.

</template>

<script>
export default {
    name: 'MadeByRealtruckMessage',
    props: {
        brand: {
            type: String,
            default: null,
        },
    },
    computed: {
        renderMessaging() {
            if (!this.brand) return false

            return !!(
                this.$sitewideData.config.madeByRealTruckBrands?.data.includes(this.brand) ||
                this.$sitewideData.config.madeByRealTruckOnlineOnlyBrands?.data.includes(this.brand)
            )
        },
    },
}
</script>
